import { HTMLAttributes, ReactNode } from 'react'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  header?: ReactNode
  footer?: ReactNode
  gradient?: string
}

export function Card({ header, footer, gradient, className = '', children, ...props }: CardProps) {
  const base = gradient ? `card-gradient ${gradient}` : 'card'
  return (
    <div className={`${base} ${className}`} {...props}>
      {header}
      <div className="p-5">
        {children}
      </div>
      {footer}
    </div>
  )
}